// extracted by mini-css-extract-plugin
module.exports = {"container":"HomePage_container__1MvRB","content":"HomePage_content__1Uea5","navigation":"HomePage_navigation__3xCqY"};